export default "__VITE_ASSET__fe94Ca_X__"